import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function FAQ({ items, idPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((f, i) => (
        <AccordionItem
          key={i}
          value={`${idPrefix}-${i}`}
          className="border-b border-warm-200"
        >
          <AccordionTrigger
            data-testid={`${idPrefix}-question-${i}`}
            className="text-left font-sans text-base sm:text-lg font-medium text-slate-900 hover:text-navy-800 py-5 hover:no-underline"
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent
            data-testid={`${idPrefix}-answer-${i}`}
            className="text-sm sm:text-base leading-relaxed text-slate-600 pb-5"
          >
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
